import {
  // createAction,
  handleActions
} from "redux-actions";
import {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_REVENUE_SUCCESS,
  FETCH_REVENUE_BY_TYPE_SUCCESS,
  FETCH_YEAR_OVER_YEAR_SUCCESS,
  REMOVE_REVENUE_CATEGORY,
  ADD_REVENUE_CHART_SUCCESS,
  SET_REVENUE_TYPES_CHECKED,
  REMOVE_REVENUE_CATEGORY_SUCCESS
} from "../sagas/revenue/revenue";
// Name Spaced Action Types
export const actions = {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_REVENUE_SUCCESS,
  FETCH_REVENUE_BY_TYPE_SUCCESS,
  FETCH_YEAR_OVER_YEAR_SUCCESS,
  SET_REVENUE_TYPES_CHECKED
};

// createAction is a lib for creating FSAs
// see https://github.com/acdlite/flux-standard-action, for info in the flux standard action
export const actionCreators = {};

export const initialState = {
  allRevenues: {},
  currencySymbol: "",
  currentUser: {},
  revenuesTypes: [],
  revenuesByType: [],
  yearOverYearComparison: [],
  initialized: false,
  revenueTypesChecked: {},
  revenueTypesCheckedMax: false,
  isLoading: true,
  forecastTooltip: ""
};

export function getTypeValues(data) {
  let types = [];
  data.map((item) => {
    types.push(item.id);
  });
  return types;
}

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser
    }),
    [REMOVE_REVENUE_CATEGORY]: (state, action) => ({
      ...state,
      revenuesByType: state.revenuesByType.filter((rev) => rev.id !== action.payload.id)
    }),
    [FETCH_REVENUE_SUCCESS]: (state, action) => ({
      ...state,
      initialized: action.payload.initialized || state.initialized,
      allRevenues: action.payload.totalRevenueObject || state.allRevenues,
      forecastTooltip: action.payload.forecastTooltip || ""
    }),
    [FETCH_REVENUE_BY_TYPE_SUCCESS]: (state, action) => ({
      ...state,
      revenuesTypes: action.payload.revenuesTypes || state.revenuesTypes,
      revenuesByType: action.payload.revenuesByType.slice(0, 3) || state.revenuesByType,
      revenueTypesChecked:
        getTypeValues(action.payload.revenuesByType.slice(0, 3)) || state.revenueTypesChecked
    }),
    [FETCH_YEAR_OVER_YEAR_SUCCESS]: (state, action) => ({
      ...state,
      yearOverYearComparison:
        action.payload.revenuesYearOverYearComparison.slice(0, 13) || state.yearOverYearComparison
      // isLoading: false
    }),
    [SET_REVENUE_TYPES_CHECKED]: (state, action) => ({
      ...state,
      revenueTypesChecked: action.payload.filtered || state.revenueTypesChecked,
      revenueTypesCheckedMax: action.payload.maxChecked
    }),
    [ADD_REVENUE_CHART_SUCCESS]: (state, action) => ({
      ...state,
      revenuesByType: action.payload.revenuesByType
    }),
    [REMOVE_REVENUE_CATEGORY_SUCCESS]: (state, action) => ({
      ...state,
      revenuesByType: action.payload.revenuesByType || state.revenuesByType,
      revenueTypesCheckedMax: false,
      revenueTypesChecked: getTypeValues(action.payload.revenuesByType) || state.revenueTypesChecked
    })
  },
  initialState
);
